import { Fetch } from 'lib/Fetch';

export function voluntaryAccountBlocking() {
  return new Fetch()
    .url('/user/characteristic-client/voluntary-block')
    .method('patch')
    .userToken()
    .send();
}
